module.exports = __webpack_public_path__ + "static/media/d-a-m-n.c3afed0a.jpg";